import { ChangeDetectionStrategy, Component, signal, ViewChild } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Title } from '@angular/platform-browser';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { SystemMessageService } from 'app/core/system-message/system-message-service';
import { SilkierHistoryVm } from 'app/shared/generated/Silkier/Models/SilkierHistoryVm';
import { TableComponent } from 'app/shared/table/table.component';
import { TableModule } from 'app/shared/table/table.module';
import { ButtonModule } from 'primeng/button';
import { ToggleButtonModule } from 'primeng/togglebutton';
import { ViewExceptionModalComponent } from '../view-exception-modal/view-exception-modal.component';
import { ViewLogModalComponent } from '../view-log-modal/view-log-modal.component';

@Component({
    selector: 'pcg-silkier-history',
    templateUrl: './silkier-history.component.html',
    styleUrls: ['./silkier-history.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [FormsModule, TableModule, ReactiveFormsModule, ButtonModule, ToggleButtonModule],
})
export class SilkierHistoryComponent {
    // Silkier History Table
    @ViewChild(TableComponent, { static: true }) table: TableComponent<SilkierHistoryVm>;
    columns = SilkierHistoryVm.ColumnDefs;
    showTimeElapsed = signal<boolean>(false);

    constructor(
        public title: Title,
        public ms: SystemMessageService,
        public modalService: NgbModal,
    ) {
        title.setTitle('Quartz History');
    }

    getTimeElapsed(row: SilkierHistoryVm): string {
        if (!row.actualFireTimeUtc || !row.finishedTimeUtc) {
            return '—';
        }
        const start = new Date(row.actualFireTimeUtc).getTime();
        const end = new Date(row.finishedTimeUtc).getTime();
        const ms = end - start;
        if (ms < 0) {
            return '—';
        }
        const totalSeconds = Math.floor(ms / 1000);
        const hours = Math.floor(totalSeconds / 3600);
        const minutes = Math.floor((totalSeconds % 3600) / 60);
        const seconds = totalSeconds % 60;
        if (hours > 0) {
            return `${hours}h ${minutes}m ${seconds}s`;
        }
        if (minutes > 0) {
            return `${minutes}m ${seconds}s`;
        }
        return `${seconds}s`;
    }

    viewLogMessage(id: number) {
        const modal = this.modalService.open(ViewLogModalComponent, { size: <any>'xl', animation: false });
        (<ViewLogModalComponent>modal.componentInstance).id = id;
    }

    viewExceptionMessage(id: number) {
        const modal = this.modalService.open(ViewExceptionModalComponent, { size: <any>'xl', animation: false });
        (<ViewExceptionModalComponent>modal.componentInstance).id = id;
    }
}
